/**
 * UUID4 generator
 * @method uuid
 * @return {string} A uuid
 */
window.duo.uuid = () => {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

/**
 * Returns the form field value for a given node
 * @method fieldValue
 * @param  {Node}   node The node
 * @return               The form value
 */
window.duo.fieldValue = (node, display = false) => {
	let value = node.value;

	if (node.tagName == 'INPUT') {

		//
		// Set the getValue function for checkboxes
		if (node.type == 'checkbox') {
			const name = node.name;
			if ((name || '').endsWith('[]')) {

				//
				// The node is part of a group
				let values = [];
				document.querySelectorAll(`[name="${ name }"]`).forEach(checkbox => {
					if (checkbox.checked) {
						values.push(checkbox.value);
					}
				});

				value = values;

				if (display) {
					value = value.map(val => {
						const q = `label[for="${ name.substring(0, name.length - 2) }_${ val }"]`;
						const label = document.querySelector(q);
						return label ? label.innerText : '';
					}).join(', ');
				}
			} else {
				value = node.checked ? 1 : 0;
				if (display) {
					value = node.checked ? 'An' : 'Aus';
				}
			}
		}

		if (node.type == 'hidden') {
			const name = node.name;
			if ((name || '').endsWith('[]')) {

				//
				// The node is part of a group
				let values = [];
				document.querySelectorAll(`[name="${ name }"]:not([validation-ignore])`).forEach(hidden => {
					values.push(hidden.value);
				});

				value = values;
			} else {
				value = node.value
			}
		}

		//
		// Set the getValue function for radio buttons
		if (node.type == 'radio') {
			const buttons = document.querySelectorAll(`input[name="${ node.name }"]`);
			value = null;
			buttons.forEach(button => {
				if (button.checked) {
					value = button.value;
					if (display) {
						const label = document.querySelector(`label[for="${ button.id }"]`);
						value = label ? label.innerText : '';
					}
				}
			});

			if (value === null && display === true) {
				value = '';
			}
		}
	}

	if (node.tagName === 'SELECT' && display === true) {
		const option = node.querySelector('option[value="' + node.value + '"]')
		value = option ? option.innerText : '';
	}

	return value;
}

/**
 * Transforms a string value into a date object
 * @param {String} value The string value such as "01.01.2021", "05.2022", "2023" (all of them are valid)
 * @returns {Date} The date object
 */
window.duo.dateValueFromString = (value) => {
    const normalized = value.split('.').reverse().join('-');
    return new Date(normalized);
}
